import { render, staticRenderFns } from "./LuckyProductCheck.vue?vue&type=template&id=5ebb88ad&lang=pug&"
import script from "./LuckyProductCheck.vue?vue&type=script&lang=js&"
export * from "./LuckyProductCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports